;(function($, window) {
    $.plugin('kbManager', {
        defaults: {
            /**
             * Shade of background color
             *
             * @property background
             * @type {String}
             */
            background: 'dark',

            /**
             * CSS class used for dark shade background
             *
             * @property darkClass
             * @type {String}
             */
            darkClass: 'kb-dark',

            /**
             * CSS class used for light shade background
             *
             * @property lightClass
             * @type {String}
             */
            lightClass: 'kb-light',

            /**
             * CSS class used when off canvas menu is open
             *
             * @property menuClass
             * @type {String}
             */
            menuClass: 'kb-menu-open',

            desktopBreak: 1025,

            menuMapSelector: '#map_canvas_menu'
        },
        /**
         * Initializes the plugin and sets up the necessary event handler
         */
        init: function() {
            const me = this;
            me.$body = me.$el.find('body');
            me.$content = me.$el.find('#page-content');
            me.opts.background = me.$content.hasClass('dark-content')?'light':'dark';
            me.ajaxPrintActive = false;
            me.$menuMap = me.$el.find(me.opts.menuMapSelector);
            if (me.touchDevice = me.isTouchDevice())
                me.$el.addClass('is-touch');
            me.callScripts();
            me.registerEvents();
        },

        registerEvents: function() {
            const me = this;
            me._on(window, 'resize', $.proxy(me.onResize, me));
            $.subscribe('kb/beforeAjaxPageLoad', $.proxy(me.beforeAjax, me));
            $.subscribe('kb/onAjaxPageLoad', $.proxy(me.onAjax, me));
            $.subscribe('kb/afterAjaxPageLoad', $.proxy(me.afterAjax, me));
            $.subscribe('kb/openMenu', $.proxy(me.onMenuOpen, me));
            $.subscribe('kb/closeMenu', $.proxy(me.onMenuClose, me));
            $.subscribe('kb/scrollBackTop', $.proxy(me.scrollBackTop, me));
            $.subscribe('kb/callContactMap', $.proxy(me.loadMaps, me));
        },

        isDesktop: function() {
            return window.innerWidth >= this.opts.desktopBreak;
        },

        isTouchDevice: function() {
            const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
            const mq = function(query) {
                return window.matchMedia(query).matches;
            }

            if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
                return true;
            }

            // include the 'heartz' as a way to have a non matching MQ to help terminate the join
            // https://git.io/vznFH
            const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
            return mq(query);
        },

        onResize: function() {
            const me = this;
            const desk = me.isDesktop();
            if (desk && me.hasMultiScroll && !me.multiScrollActive)
                me.buildMultiScroll();
            else if (!desk && me.hasMultiScroll && me.multiScrollActive)
                me.destroyMultiScroll();
        },

        setBodyClasses: function() {
            const me = this;
            const opts = me.opts;
            me.$body.removeClass(opts.darkClass+' '+opts.lightClass).addClass(opts[opts.background==='dark'?'darkClass':'lightClass']);
        },

        scrollBackTop: function() {
            const me = this;
            me.$el.animate({scrollTop:0}, 500, 'swing');
        },

        onMenuOpen: function() {
            const me = this;
            const opts = me.opts;
            me.$body.addClass(opts.menuClass);
            me.multiMenu.open();
        },

        onMenuClose: function() {
            const me = this;
            const opts = me.opts;
            me.$body.removeClass(opts.menuClass);
            setTimeout(function() {
                me.multiMenu.close();
            }, 200);
        },

        beforeAjax: function() {
            const me = this;
            const opts = me.opts;
            if (me.multiScrollActive)
                $.fn.multiscroll.destroy();
            me.$body.removeClass(opts.menuClass);
            setTimeout(function() {
                me.multiMenu.close();
            }, 200);
        },

        onAjax: function() {
            const me = this;
            me.ajaxPrintActive = true;
            me.$menuMap = me.$el.find(me.opts.menuMapSelector);
            if (me.$menuMap.length)
                me.$menuMap.detach();
        },

        afterAjax: function(event, content) {
            const me = this;
            const bodyTag = content.match(/<body[^>]*>/is)[0];
            const bodyCls = bodyTag.match(/class=["|\']([^"]*)["|\']/is);
            const cls = (typeof bodyCls[1] === 'string')?bodyCls[1].split(/\s+/):[];
            const checkClasses = ['page-template-page-full', 'page-template-page-contact', 'page-template-showcase-page', 'page-template-page-minimal'];

            me.$content = me.$el.find('#page-content');
            me.opts.background = me.$content.hasClass('dark-content')?'light':'dark';
            me.setBodyClasses();
            me.callScripts();

            checkClasses.forEach(function(value) {
                if (cls.indexOf(value) > -1) {
                    me.$body.addClass(value);
                } else {
                    me.$body.removeClass(value);
                };
            });

            if (me.$menuMap.length)
                me.$el.find(me.opts.menuMapSelector).replaceWith(me.$menuMap);

            me.ajaxPrintActive = false;
        },

        loadMaps: function() {
            window.grenada.ContactMap(this.ajaxPrintActive);
        },

        callScripts: function() {
            const me = this;
            const $ms = me.$el.find('.wp-block-kb-split-slider');
            me.multiMenu = me.$el.find('nav.menu-main-container').multiMenu().data('plugin_multiMenu');
            if (me.hasMultiScroll = !!$ms.length) {
                const lItems = $ms.find('.ms-left').children();
                const rItems = $ms.find('.ms-right').children();
                const $msM = $('<div class="wp-block-kb-split-slider split-slider-mobile"></div>');
                $ms.addClass('split-slider-desktop').multiscroll({
                    css3: true,
                    menu: true
                });
                if (me.isDesktop())
                    this.multiScrollActive = true;
                else
                    me.destroyMultiScroll();
                for (let i=0;i<lItems.length;i++) {
                    $(lItems[i]).clone().appendTo($msM);
                    $(rItems[i]).clone().appendTo($msM);
                }
                $ms.after($msM);
            }
            me.$el[$ms.length?'addClass':'removeClass']('kb-split-slider-active');
            me.$body[$ms.length?'addClass':'removeClass']('kb-split-slider-active');
            me.$el.find('.wp-block-kb-split-slider .vs-right-item').teBanner();
        },

        buildMultiScroll: function() {
            $.fn.multiscroll.build();
            this.multiScrollActive = true;
        },

        destroyMultiScroll: function() {
            $.fn.multiscroll.destroy();
            this.multiScrollActive = false;
        }
    });
})(jQuery, window);
